import React, { memo } from 'react';
import Select from 'react-select';
import { stillageTypes } from 'services/stillageDashboard';
import PropTypes from 'prop-types';

const TypeSelect = ({ currentOption, onChangeType, stillageNo }) => {
    return (
        <div onClick={e => { e.stopPropagation(); }}>
            <Select
                autoFocus
                menuIsOpen
                isSearchable={false}
                isClearable={false}
                placeholder="Select new type..."
                value={currentOption.label}
                onChange={opt => {
                    if (!opt) return;
                    onChangeType(stillageNo, opt.value);
                }}
                options={Array.from(Object.entries(stillageTypes)).map(([key, opt]) => ({
                    value: key,
                    label: <span dangerouslySetInnerHTML={{ __html: opt.label }} />,
                }))}
                // basic style so it fits in a table cell
                styles={{
                    container: base => ({
                        ...base,
                        border: 'none',
                    }),
                    control: base => ({
                        ...base,
                        height: '1rem',
                        fontSize: '0.8rem',
                        width: '150px',
                        border: 'none',
                    }),
                    menu: base => ({
                        ...base,
                        zIndex: 9999,
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                    indicatorsContainer: () => ({ display: 'none' }),
                }}
            />
        </div>
    )
}

TypeSelect.propTypes = {
    currentOption: PropTypes.object,
    onChangeType: PropTypes.func,
    stillageNo: PropTypes.number,
};

export default memo(TypeSelect);